// import React from "react";

import { useLocaContext } from "@biz/language/LocaContext";

export const CurtainPointName = (props: {
  cornerIndex: number;

}) => {
  const { cornerIndex } = props;
  const lc = useLocaContext();
  return cornerIndex === 0 ? lc.C("Curtain_StartPoint") : <>{lc.C("Curtain_Point")} {cornerIndex}</>
}


export const CurtainClothName = (props: {
  index: number;

}) => {
  const { index } = props;
  const lc = useLocaContext();
  return <>{lc.C("Curtain_Cloth")} {index + 1}</>
}